import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { PRODUCTS_AND_SERVICES_ADVANTAGES_NAMES } from 'components/BusinessToolForm/Sections/ProductsAndServices/ProductAndServicesAdvantages/utils/form';
import { PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES } from 'components/BusinessToolForm/Sections/ProductsAndServices/ProductAndServicesDeliveryAndSupport/utils/form';
import {
  KEY_FEATURES_NAMES,
  PRODUCT_AND_SERVICES_ARRAY_NAMES,
  PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES,
} from 'components/BusinessToolForm/Sections/ProductsAndServices/ProductAndServicesDescription/utils/form';
import {
  PRODUCTS_AND_SERVICES_R_AND_D_NAMES,
  TIMELINE_ROW_NAMES,
} from 'components/BusinessToolForm/Sections/ProductsAndServices/ProductAndServicesRAndD/utils/form';

import { ol, ul } from '../helpers';

const KEY_FEATURES_INSTRUCTIONS = {
  [KEY_FEATURES_NAMES.FEATURE]: {
    name: 'Produkt-/Dienstleistungsmerkmale',
    instruction:
      'Listen Sie die wichtigsten Merkmale des Produkts knapp auf und heben Sie seine zentralen Funktionen und Vorteile hervor.',
    exampleOne: '',
    exampleTwo: '',
  },
  [KEY_FEATURES_NAMES.DESCRIPTION]: {
    name: 'Produkt-/Dienstleistungsmerkmale',
    instruction:
      'Heben Sie innovative Aspekte oder technologische Weiterentwicklungen hervor, die Ihr Angebot am Markt unterscheiden. Beschreiben Sie klar die Funktionalität, Spezifikationen und Designelemente, die zu seiner Einzigartigkeit beitragen.',
    exampleOne: ol([
      'Leistungsstark: Entwickelt, um eine robuste Performance unter anspruchsvollen Bedingungen zu gewährleisten.',
      'Kettenlaufwerk: Ein einzigartiges Kettensystem bietet überlegene Traktion und Auftrieb, insbesondere auf schweren oder nassen Böden.',
      'Patentierte Gummibeschichtung: Minimiert den Bodendruck und die Bodeneinwirkung, reduziert Pflanzenschäden und Bodenverdichtung.',
    ]),
    exampleTwo: ol([
      'Genauigkeit: Übersetzungsdienste und KI-gestützte Tools legen Priorität auf Präzision und Korrektheit, sodass die Kommunikation in jeder Sprache der ursprünglichen Botschaft treu bleibt.',
      'Effizienz: Durch den Einsatz fortschrittlicher KI-Technologie optimiert das Unternehmen den Übersetzungsprozess, ermöglicht schnellere Durchlaufzeiten ohne Qualitätsverlust und steigert so die Gesamtproduktivität.',
    ]),
  },
};

const DEVELOPMENT_TIMELINE_INSTRUCTIONS = {
  [TIMELINE_ROW_NAMES.STAGE]: {
    name: 'Entwicklungszeitplan',
    instruction:
      'Gehen Sie bei Fragen zum Projektzeitplan wie folgt vor:' +
      ol([
        'Skizzieren Sie die wichtigsten Phasen von der Konzeption bis zur Markteinführung.',
        'Geben Sie die geschätzte Dauer für jede Phase an.',
        'Geben Sie an, in welcher Phase Sie sich aktuell befinden.',
      ]),
    exampleOne: ul([
      'Konzept & Design: 6 Monate.',
      'Prototyping & Tests: 9 Monate.',
      'Einrichtung der Produktion: 3 Monate.',
      'Marketing & Launch-Vorbereitung: 2 Monate.',
      'Derzeit in der Phase der Produktionseinrichtung.',
    ]),
    exampleTwo: ul([
      'Konzeptphase: 3 Monate.',
      'Design und Prototyping: 6 Monate.',
      'Tests und Iterationen: 4 Monate.',
      'Finalisierung und Produktion: 3 Monate.',
      'Derzeit in der Phase von Tests und Iterationen.',
    ]),
  },
};

const KEY_FEATURES_AND_BENEFITS_INSTRUCTIONS = {
  [PRODUCT_AND_SERVICES_ARRAY_NAMES.DESCRIPTION]: KEY_FEATURES_INSTRUCTIONS,
  [PRODUCT_AND_SERVICES_ARRAY_NAMES.FILE]: {
    name: '',
    instruction:
      'Fügen Sie ein hochwertiges Foto des Produkts bzw. der Dienstleistung hinzu. Stellen Sie sicher, dass das Bild gut ausgeleuchtet und professionell aufgenommen ist.',
    exampleOne: '',
    exampleTwo: '',
  },
  [PRODUCT_AND_SERVICES_ARRAY_NAMES.VALUE]: {
    name: 'Produkt-/Dienstleistungsname',
    instruction:
      'Geben Sie den Namen des Produkts oder der Dienstleistung an. Verwenden Sie eine klare Fachterminologie, die Ihr Angebot am besten beschreibt.',
    exampleOne: '',
    exampleTwo: '',
  },
};

const QUALITY_CERTIFICATIONS_DESCRIPTION_INSTRUCTIONS = {
  [PRODUCT_AND_SERVICES_ARRAY_NAMES.VALUE]: {
    name: 'Name der Qualitätszertifizierung',
    instruction:
      'Geben Sie eine übersichtliche Liste relevanter Zertifizierungen an, wie z. B. ISO 9001 für Qualitätsmanagement.',
    exampleOne: 'EcoGrain Zertifiziert',
    exampleTwo: 'EnviroCrop Zertifiziert',
  },

  [PRODUCT_AND_SERVICES_ARRAY_NAMES.DESCRIPTION]: {
    name: 'Beschreibung der Qualitätszertifizierungen',
    instruction:
      'Geben Sie eine übersichtliche Liste relevanter Zertifizierungen an, wie z. B. ISO 9001 für Qualitätsmanagement. Erklären Sie kurz die Bedeutung jeder Zertifizierung und bieten Sie an, bei Bedarf weitere Details bereitzustellen.',
    exampleOne:
      'EcoGrain Zertifiziert garantiert, dass Getreide unter umweltfreundlichen Bedingungen produziert wird, etwa durch biologische Anbaumethoden, minimalen Einsatz von Pestiziden und nachhaltiges Wassermanagement. Diese Zertifizierung versichert den Verbrauchern, dass das Produkt ökologischen Standards entspricht und Biodiversität sowie Naturschutz fördert.',
    exampleTwo:
      'EnviroCrop Zertifiziert steht für den Anbau von Nutzpflanzen mit Fokus auf Umweltschutz und Nachhaltigkeit. Diese Zertifizierung garantiert, dass landwirtschaftliche Praktiken wie Bodenschutz, Fruchtwechsel und natürliche Schädlingsbekämpfung eingesetzt werden, um ökologische Auswirkungen zu minimieren und natürliche Ressourcen zu erhalten. Verbraucher können darauf vertrauen, dass Produkte mit dieser Zertifizierung umweltfreundliche Anbaumethoden unterstützen und zum Naturschutz beitragen.',
  },
};

const PARENTS_OR_TRADEMARKS_DESCRIPTION_INSTRUCTIONS = {
  [PRODUCT_AND_SERVICES_ARRAY_NAMES.VALUE]: {
    name: 'Name des geistigen Eigentums',
    instruction:
      'Stellen Sie eine prägnante Liste relevanter Patente und Marken zusammen. Nennen Sie deren Bezeichnungen, Registrierungsnummern und eine kurze Beschreibung ihrer Bedeutung.',
    exampleOne: 'InnoGrain™-Technologie',
    exampleTwo: 'SmartSeed-Technologie',
  },
  [PRODUCT_AND_SERVICES_ARRAY_NAMES.DESCRIPTION]: {
    name: 'Beschreibung des geistigen Eigentums',
    instruction:
      'Stellen Sie eine prägnante Liste relevanter Patente und Marken zusammen. Nennen Sie deren Bezeichnungen, Registrierungsnummern und eine kurze Beschreibung ihrer Bedeutung.',
    exampleOne:
      'Die InnoGrain™-Technologie umfasst patentierte Verfahren und Innovationen in der Getreidezucht, im Anbau und in der Lagerung. Sie gewährleistet überlegene Getreidesorten mit verbesserten Eigenschaften wie höheren Erträgen, Krankheitsresistenz und gesteigertem Nährwert. Diese proprietäre Technologie sichert dem Unternehmen einen Wettbewerbsvorteil am Markt und schützt seine einzigartigen Fortschritte in der Agrarwissenschaft.',
    exampleTwo:
      'Die SmartSeed-Technologie beinhaltet fortschrittliche Verfahren und genetische Innovationen zur Entwicklung leistungsstarker Saatgutsorten. Diese Saaten werden auf Widerstandsfähigkeit gegen Schädlinge und Krankheiten, höheres Ertragspotenzial und optimierte Nährstoffaufnahme ausgelegt. Durch den Einsatz der SmartSeed-Technologie können Landwirte ihre Kulturen effizienter anbauen, den Bedarf an chemischen Betriebsmitteln reduzieren und nachhaltige landwirtschaftliche Praktiken fördern, während gleichzeitig eine konstante Erntequalität und Produktivität gewährleistet wird.',
  },
};

const DESCRIPTION_INSTRUCTIONS = {
  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.PRODUCTS_OR_SERVICES_AND_THEIR_PURPOSE]: {
    name: 'Produkt-/Dienstleistungsübersicht',
    instruction:
      'Erstellen Sie eine strukturierte Liste Ihrer Produkte oder Dienstleistungen. Gruppieren Sie diese in Kategorien oder heben Sie Ihre wichtigsten Angebote hervor, die Ihr Unternehmen prägen. Betonen Sie die zentralen Merkmale oder Eigenschaften, die Ihre Produkte oder Dienstleistungen von denen Ihrer Wettbewerber unterscheiden, wie beispielsweise Innovation, Qualität oder Alleinstellungsmerkmale.',
    exampleOne:
      'Das Unternehmen ist auf die Herstellung leistungsstarker Raupentraktoren spezialisiert, die für schwere oder nasse Böden konzipiert sind. Zum Produktportfolio gehören:' + 
      ol([
        'Raupentraktoren',
        'Landwirtschaftliche Maschinen',
        'Umweltlösungen'
      ]),

    exampleTwo:
      'Das Unternehmen bietet eine Reihe von Produkten und Dienstleistungen an, die darauf ausgelegt sind, globale Kommunikations- und Interaktionsprozesse zu optimieren. Das Angebot umfasst:' + 
      ol([
        'Übersetzungsdienste',
        'KI-basierte Übersetzungswerkzeuge',
        'Lösungen zur Optimierung der Kommunikation',
        'Innovative technologische Lösungen'
      ]),
  },
  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.KEY_FEATURES_AND_BENEFITS]:
    KEY_FEATURES_AND_BENEFITS_INSTRUCTIONS,
  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.QUALITY_STANDARDS]: {
    name: 'Qualitätsstandards',
    instruction:
      'Stellen Sie klar, dass Ihre Produkte/Dienstleistungen internationalen Qualitätsstandards wie ISO 9001:2015 entsprechen und damit Beständigkeit und Exzellenz gewährleisten. Skizzieren Sie kurz zusätzliche, für Ihre Branche relevante spezifische Standards.',
    exampleOne:
      'Die Produkte des Unternehmens entsprechen international anerkannten Qualitätsstandards, einschließlich ISO 9001:2015, was Beständigkeit und Exzellenz in Fertigungsprozessen und Produktqualität sicherstellt. Zusätzlich erfüllt das Unternehmen branchenspezifische Standards wie ASTM International für Materialien und Leistungstests im Bereich Landmaschinen.',
    exampleTwo:
      'Die Produkte und Dienstleistungen des Unternehmens entsprechen internationalen Qualitätsstandards wie ISO 9001:2015 und gewährleisten damit Beständigkeit und Exzellenz in den Abläufen. Zusätzlich folgt das Unternehmen branchenspezifischen Standards wie ASTM F2575 für die Qualitätssicherung von Übersetzungen, um durchgehend hohe Qualitätsstandards aller Leistungen zu gewährleisten.',
  },
  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.QUALITY_CERTIFICATIONS]:
    QUALITY_CERTIFICATIONS_DESCRIPTION_INSTRUCTIONS,
  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.PATENTS_OR_TRADEMARKS]:
    PARENTS_OR_TRADEMARKS_DESCRIPTION_INSTRUCTIONS,
};

const ADVANTAGES_INSTRUCTIONS = {
  [PRODUCTS_AND_SERVICES_ADVANTAGES_NAMES.PRODUCT_VALUE]: {
    name: 'Kundennutzen',
    instruction:
      'Formulieren Sie klar den Hauptnutzen Ihres Produkts und welches Problem es löst. Erläutern Sie die Vorteile, die Kunden aus der Nutzung Ihres Produkts ziehen. Heben Sie hervor, wie Ihr Produkt das Leben erleichtert, Zeit oder Geld spart oder das Gesamterlebnis verbessert.',
    exampleOne:
      'Durch die Minimierung der Bodenverdichtung und die Maximierung der Traktion ermöglichen die Kettenfahrzeuge den Landwirten, effizienter zu arbeiten und Aufgaben schneller sowie präziser zu erledigen.',
    exampleTwo:
      'Die Sprachdienstleistungsplattform ermöglicht eine nahtlose Kommunikation über Sprachbarrieren hinweg und versetzt Kunden in die Lage, sich effektiv mit globalen Zielgruppen zu vernetzen und ihre Reichweite zu vergrößern.',
  },
};

const R_AND_D_INSTRUCTIONS = {
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.READINESS_LEVEL]: {
    name: 'Produktions- und Implementierungsreife',
    instruction:
      'Beschreiben Sie den Fortschritt knapp: „Vollständig eingeführt“ bedeutet, dass das Produkt/die Dienstleistung verfügbar und operativ ist; „Abschluss der Testphase“ deutet darauf hin, dass die Fertigstellung kurz bevorsteht; „In Entwicklung“ zeigt laufende Arbeiten bis zur Marktreife; „Konzeptphase“ signalisiert die frühen Entwicklungsstadien.',
    exampleOne:
      'Die Kettenfahrzeuge sind vollständig eingeführt, käuflich erhältlich und im Einsatz, wobei umfangreiche Feldtests Leistung und Zuverlässigkeit bestätigen.',
    exampleTwo: 'Die Übersetzungs-App befindet sich derzeit in Entwicklung, mit geplanter Markteinführung in sechs Monaten.',
  },
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.CONDUCTED_ACTIVITIES]: {
    name: 'F&E-Fortschritt',
    instruction:
      'Geben Sie eine kurze Zusammenfassung:' +
      ol([
        'Heben Sie die wichtigsten Forschungsbereiche und -ziele hervor.',
        'Nennen Sie Ergebnisse wie Durchbrüche, Innovationen oder Entdeckungen.',
        'Bieten Sie an, auf Anfrage detaillierte Berichte oder Ergebnisse zur Verfügung zu stellen.',
      ]),
    exampleOne:
      'Die F&E konzentrierte sich auf die Steigerung der Effizienz der Fahrzeuge, die Reduktion der Umweltauswirkungen und die Verbesserung der Bodengesundheit. Zu den Durchbrüchen gehört das patentierte Kettenlaufwerk. Detaillierte Berichte sind auf Anfrage verfügbar.',
    exampleTwo:
      'Die F&E konzentriert sich auf die Verbesserung der Übersetzungsgenauigkeit und -geschwindigkeit durch KI-Algorithmen. Durchbrüche umfassen eine Steigerung der Übersetzungseffizienz um 20 %. Detaillierte Berichte sind auf Anfrage verfügbar.',
  },
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.TIMELINES]: DEVELOPMENT_TIMELINE_INSTRUCTIONS,
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.RESOURCES]: {
    name: 'Erforderliche Ressourcen',
    instruction:
      'Geben Sie einen umfassenden Überblick über die kritischen Ressourcen, die für die erfolgreiche Entwicklung Ihres Produkts oder Ihrer Dienstleistung erforderlich sind. Unterteilen Sie diese Ressourcen in technische, finanzielle, personelle und andere relevante Kategorien.',
    exampleOne:
      'Zu den kritischen Ressourcen gehören:' +
      ol([
        'Technisch: Hochentwickelte Produktionsanlagen, Software für Design und Simulation.',
        'Finanziell: Finanzierung für F&E, Produktionsaufbau und Marketing.',
        'Personell: Ingenieure, Techniker, Marketing-Spezialisten.',
        'Sonstige: Regulatorische Genehmigungen, Partnerschaften in der Lieferkette.',
      ]),
    exampleTwo: ol([
      'Technisch: Softwareentwicklungs-Tools, KI-Algorithmen',
      'Finanziell: Finanzierung für Forschung und Anschaffung von Ausrüstung',
      'Personell: Softwareentwickler, KI-Spezialisten',
      'Sonstige: Marktforschungsdaten, rechtliche Unterstützung',
    ]),
  },
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.WEAKNESSES]: {
    name: 'Produktmängel und Lösungsansätze',
    instruction:
      'Erkennen Sie eventuelle Mängel oder Schwächen der aktuellen Produktversion an. Zeigen Sie klar, dass Ihnen Kundenfeedback oder Branchenstandards, die diese Mängel hervorheben, bewusst sind. Gehen Sie im Detail auf konkrete Strategien und Zeitrahmen ein, mit denen die identifizierten Mängel behoben werden sollen.',
    exampleOne:
      'Das Unternehmen adressiert Bedenken hinsichtlich der Kraftstoffeffizienz der Fahrzeuge, indem es die Motorleistung und Aerodynamik optimiert. Die Umsetzung ist innerhalb des nächsten Jahres geplant, um Branchenstandards zu erfüllen und die Betriebskosten zu senken.',
    exampleTwo:
      'Das Unternehmen erkennt das Nutzerfeedback zu gelegentlichen Übersetzungsungenauigkeiten an. Das Team verbessert die KI-Algorithmen mit dem Ziel, die Genauigkeit innerhalb der nächsten drei Monate um 15 % zu steigern.',
  },
};

const DELIVERY_AND_SUPPORT_INSTRUCTIONS = {
  [PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES.LOGISTICS]: {
    name: 'Logistik und Lieferung',
    instruction:
      'Beschreiben Sie Ihren Versandprozess und heben Sie Partnerschaften mit Logistikdienstleistern oder Fulfillment-Zentren hervor. Erwähnen Sie Strategien, um Versandprobleme zeitnah zu lösen.',
    exampleOne:
      'Das Unternehmen arbeitet mit renommierten Logistikdienstleistern für den weltweiten Versand zusammen. Bestellungen werden zügig bearbeitet, mit Echtzeit-Tracking. Rücksendungen werden über einen schlanken Prozess abgewickelt, der eine schnelle Lösung und hohe Kundenzufriedenheit sicherstellt.',
    exampleTwo:
      'Das Unternehmen kooperiert mit zuverlässigen Logistikpartnern für den weltweiten Versand. Bestellungen werden innerhalb von 24 Stunden bearbeitet und können nachverfolgt werden. Das Unternehmen bietet unkomplizierte Rücksendungen und löst Versandprobleme zeitnah über einen dedizierten Kundenservice.',
  },
  [PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES.POST_PURCHASE]: {
    name: 'Support- und Wartungsleistungen',
    instruction:
      'Geben Sie einen kompakten Überblick über Ihre umfassenden Kundenbetreuungsmaßnahmen. Heben Sie zunächst die angebotenen Unterstützungsleistungen hervor, wie technischen Support, Anleitungen zur Fehlerbehebung und Reparaturservices. Legen Sie klar dar, über welche Kanäle Kunden Support erhalten können, einschließlich Online-Ressourcen, spezieller Hotlines und Servicezentren.',
    exampleOne:
      'Das Unternehmen bietet umfassenden Support nach dem Kauf, einschließlich technischer Unterstützung, Anleitungen zur Fehlerbehebung und Reparaturservices. Kunden können Support über Online-Ressourcen, spezielle Hotlines oder durch den Besuch unserer Servicezentren weltweit erhalten.',
    exampleTwo:
      'Das Unternehmen bietet rund um die Uhr technischen Support, Anleitungen zur Fehlerbehebung und Reparaturservices. Kunden können Support über Online-Ressourcen, spezielle Hotlines oder durch den Besuch unserer Servicezentren weltweit erhalten.',
  },
  [PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES.ANY_WARRANTY]: {
    name: 'Garantie- und Rückgabeprogramme',
    instruction:
      'Beschreiben Sie klar alle Garantien, die mit Ihren Produkten angeboten werden, einschließlich Dauer und Bedingungen der Abdeckung. Erläutern Sie Ihren Rückgabeprozess, heben Sie Teilnahmevoraussetzungen, Rückgabefrist und die Schritte zur Einleitung einer Rückgabe hervor.',
    exampleOne:
      'Die Produkte werden mit einer 1-jährigen Garantie auf Herstellungsfehler angeboten. Rückgaben werden innerhalb von 30 Tagen nach dem Kauf für berechtigte Artikel im Originalzustand akzeptiert. Kunden leiten Rückgaben ein, indem sie unseren Kundenservice für eine Rückgabeautorisierung und Versandhinweise kontaktieren.',
    exampleTwo:
      'Die Sprachplattform bietet eine Zufriedenheitsgarantie. Nutzer können innerhalb von 30 Tagen nach dem Kauf eine vollständige Rückerstattung beantragen, wenn sie mit den Funktionen und der Leistungsfähigkeit der Plattform nicht vollständig zufrieden sind. Zusätzlich bieten wir eine 12-monatige Garantie für technische Probleme oder Störungen. Wenn Nutzer innerhalb dieses Zeitraums Probleme mit der Plattform haben, können sie unseren Kundenservice kontaktieren, um Unterstützung und ggf. Austausch- oder Reparaturoptionen zu erhalten.',
  },
};

export const PRODUCTS_AND_SERVICES_INSTRUCTIONS = {
  [BUSINESS_TOOL_SUB_SECTIONS.PRODUCTS_AND_SERVICES.DESCRIPTION]: DESCRIPTION_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.PRODUCTS_AND_SERVICES.ADVANTAGES]: ADVANTAGES_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.PRODUCTS_AND_SERVICES.R_AND_D]: R_AND_D_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.PRODUCTS_AND_SERVICES.DELIVERY_AND_SUPPORT]: DELIVERY_AND_SUPPORT_INSTRUCTIONS,
};
